import React, { ComponentProps } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VoltoIcon from '@plone/volto/components/theme/Icon/Icon';
import EBike from './icons/e-bike.svg';
import Snowshoes from './icons/snowshoes.svg';

interface IconProps {
  icon: string;
  prefix?: string;
  className?: string;
  title?: string;
}

const IconList = {
  'e-bike': EBike,
  snowshoes: Snowshoes,
};

const Icon: React.FC<IconProps> = (props) => {
  return Object.keys(IconList).indexOf(props.icon) >= 0 ? (
    <VoltoIcon name={IconList[props.icon]} size="1em" {...props} />
  ) : (
    <FontAwesomeIcon {...props} icon={[props.prefix ?? 'fas', props.icon]} />
  );
};

export default Icon;
